import styled from 'styled-components';

export const StyledSearchBox = styled.input`
  height: 30px;
  width: 300px;
  float: right;
  margin-left: 10px;
  border-radius: 0px;
  font-family: 'NexonBo';
`;

export const StyledSearchDiv = styled.div`
  float: right;
  margin: 30px;
`;

export const StyledSearchBtn = styled.button`
  height: 38px;
  width: 60px;
  border: 0px;
  background-color: tomato;
  border-radius: 20px;
  font-family: 'NexonBo';
  cursor: pointer;
`;
